import { removeUnwantedCharacters } from '../../../helpers';

function stripSummaryPropsContent(propsToDisplay, summaryPropsWithContent) {
  if (!propsToDisplay || !propsToDisplay[0] || !propsToDisplay[0].shouldStrip)
    return summaryPropsWithContent;

  return summaryPropsWithContent.reduce((acc, summaryProp) => {
    const [, contentWithUnwantedCharacters] = summaryProp;
    const sanitizedContent = removeUnwantedCharacters(contentWithUnwantedCharacters);

    const summaryPropsCopy = [...summaryProp];
    summaryPropsCopy[1] = sanitizedContent;

    acc.push(summaryPropsCopy);
    return acc;
  }, []);
}

export default stripSummaryPropsContent;
